import Box from "@mui/material/Box";

export default function ({children, hasHeader = true, hasFooter = true, sx = {}}) {
    return (
        <Box
            height={`calc(100dvh - ${hasHeader ? "56px" : "0dvh"} - ${hasFooter ? "8" : "0"}dvh)`}
            overflow={"auto"}
            sx={sx}
            data-test="skeleton-body"
        >
            {children}
        </Box>
    )
}